import { render, staticRenderFns } from "./CourseDetail.vue?vue&type=template&id=808629c4&"
import script from "./CourseDetail.vue?vue&type=script&lang=js&"
export * from "./CourseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports